export const italiano = { 
    modulo: 'Contributi'
}
export const inglese = {
    modulo: 'Contributi'
}